import { http } from '../../../../../api/axios';
import { collectionConfig } from '../../../../../config';
import { GenresResponse } from '../../../../../store/api';

export const fetchCollectionGenres = (params: {
    ageCategory?: string;
    loanFormat: string | null;
}): Promise<GenresResponse> => {
    return http
        .get<GenresResponse>(collectionConfig().endpointGenres, {
            params
        })
        .then(response => response.data);
};
